module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-6.e1a6628c.gif";